import Component from './Component';
import React from 'react';
import String from 'underscore.string';

export default class ClosableTab extends Component {

	handleClose(e) {
		e.preventDefault();
		e.stopPropagation();
		if (this.props.onClose) {
			this.props.onClose(this.props.id);
		}
	}

	render() {
		const truncated = String.truncate(this.props.title, 26);
		return (
			<span className="closabletab">
				<i onClick={(e) => this.handleClose(e)} className="tabclose icon-cross2"></i>
				<span>
					{truncated}
					{this.props.unsave && <span> *</span>}
				</span>
			</span>
		)
	}
}




// WEBPACK FOOTER //
// ./src/components/ClosableTab.js